<div class="frame">
  <iframe
    [src]="iframeUrl"
    scrolling="no"
    (load)="onLoad()"
  ></iframe>
</div>
